export function defaultCallback(_?: any) { }